<template>
  <div class="c-storage-deadline-notice">
    <div class="text-center mb-3">
      <h3>UChicago Storage Deadline May 14th</h3>
    </div>

    <div class="border p-4 mb-3 border-dark border-opacity-25 rounded-2 bg-light">
      <!-- Added on 2023-05-22 -->
      Missed the deadline and still need storage?
      Please email us at
      <a href="mailto:uchicago@bluecrates.com">uchicago@bluecrates.com</a>
      for custom orders and delivery options.

      <!--
      <div class="row">
        <div class="col-12 col-md-4 mb-2">
          • Cardboard Boxes
        </div>
        <div class="col-12 col-md-4 mb-2">
          • Storage Bags
        </div>
        <div class="col-12 col-md-4 mb-2">
          • Luggage
        </div>
        <div class="col-12 col-md-4 mb-2">
          • Mattress toppers
        </div>
        <div class="col-12 col-md-4 mb-2">
          • Microwaves
        </div>
        <div class="col-12 col-md-4 mb-2">
          • Mini fridges
        </div>
        <div class="col-12 col-md-4 mb-2">
          • Blue Crates Bags
        </div>
        <div class="col-12 col-md-4 mb-2">
          • Equipment
        </div>
        <div class="col-12 col-md-4 mb-2">
          • Etc
        </div>
      </div>
      -->
    </div>

    <div class="text-center">
      <!--
      <div class="mt-4 mb-4">
        <p
          v-if="isFinished"
          class="fw-bold"
        >
          SIGN UP CLOSED
        </p>
        <p v-else>
          Sign up closes in

          <span class="ms-1 text-danger fw-bold">
            {{ time.days }} days,
            {{ time.hours }} hours,
            {{ time.minutes }} minutes,
            {{ time.seconds }} seconds
          </span>
        </p>
      </div>
      -->

      <button
        class="btn btn-primary"
        @click="$emit('continue-clicked', $event)"
      >
        Continue
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

@Component
export default class StorageDeadlineAlert extends Vue {
  @Prop()
  date!: string;

  timerId!: ReturnType<typeof setInterval>;

  time = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  };

  isFinished = false;

  mounted() {
    const deadlineDate = new Date("May 15, 2023 00:00:00 CST");

    console.debug("Deadline date", deadlineDate);

    const countDownDate = deadlineDate.getTime();

    const self = this;

    this.timerId = setInterval(function () {
      const now = new Date().getTime();
      const timeLeft = countDownDate - now;

      if (timeLeft < 0) {
        self.isFinished = true;

        clearInterval(self.timerId);
      } else {
        self.time.days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
        self.time.hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        self.time.minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        self.time.seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
      }
    }, 1000);
  }
}
</script>

<style lang="scss" scoped>
@import "~styles/globals";

.c-storage-deadline-notice {
  &__bg {
    background-color: $gray-100;
  }

  &__counter {
    color: $danger;
  }

  &__text {
  }
}
</style>
